import Parent from "parentjs/controllers/related_services_controller.js";
export default Parent;
